module.exports = "/assets/34a539624cc09bab7eb6f4000a64687a.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/LS.png
// module id = 1590
// module chunks = 0